module.exports = __webpack_public_path__ + "fifoIllustration.png?0433c423c00433c1973e0f55c5c4a3e2";